var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69671 10.044L7.69677 10.0441C7.77624 10.1196 7.88921 10.1663 8.01202 10.1663L7.69671 10.044ZM7.69671 10.044L3.96338 6.49572L3.96343 6.49566M7.69671 10.044L3.96343 6.49566M3.96343 6.49566L3.95704 6.4898M3.96343 6.49566L3.95704 6.4898M3.95704 6.4898C3.91667 6.45274 3.88596 6.40981 3.86538 6.36427C3.84484 6.31881 3.83444 6.27094 3.834 6.22322C3.83356 6.1755 3.84309 6.12753 3.86274 6.08187C3.88243 6.03614 3.91225 5.99285 3.95181 5.95525C3.99142 5.9176 4.03992 5.88653 4.09511 5.86507C4.15032 5.8436 4.21029 5.83252 4.2713 5.83302C4.33231 5.83353 4.392 5.8456 4.4467 5.86793C4.50137 5.89025 4.54916 5.92203 4.58795 5.9602L4.5879 5.96026M3.95704 6.4898L4.5879 5.96026M4.5879 5.96026L4.5942 5.96624M4.5879 5.96026L4.5942 5.96624M4.5942 5.96624L7.66766 8.88737L8.01212 9.21475M4.5942 5.96624L8.01212 9.21475M8.01212 9.21475L8.35658 8.88737M8.01212 9.21475L8.35658 8.88737M8.35658 8.88737L11.4263 5.96982C11.5064 5.89754 11.6178 5.85383 11.738 5.85483C11.8594 5.85583 11.9709 5.90232 12.0495 5.97705C12.1273 6.05099 12.1665 6.14555 12.1673 6.23875C12.1681 6.33089 12.1316 6.42475 12.0571 6.4993L8.32753 10.044L8.32747 10.0441M8.35658 8.88737L8.32747 10.0441M8.32747 10.0441C8.248 10.1196 8.13503 10.1663 8.01222 10.1663L8.32747 10.0441Z",
    fill: "#6B7280",
    stroke: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/select_icon.09b519482a99359cb0096e3f6351e305.svg";
export { ForwardRef as ReactComponent };